const global = window

// Remplissage automatique
inputs.behavior.fill = function (data, name, niceName, type, input, parent, inputWindow) {
    let statusUpdate = function(event) {
        var formTags = ['INPUT', 'SELECT', 'TEXTAREA'];
        if (formTags.includes(this.tagName)) {
            if (typeof $(this).val() === 'string') {
                if ($(this).val().length > 0) {
                    if (!$(this).hasClass('field__input--filled')) {
                        $(this).addClass('field__input--filled');
                        $(this).removeClass('field__input--empty');
                    }
                    $(this).addClass('field__input--filled');
                }
                else {
                    if (!$(this).hasClass('field__input--empty')) {
                        $(this).addClass('field__input--empty');
                        $(this).removeClass('field__input--filled');
                    }
                    $(this).addClass('field__input--empty');
                }
            }
        }
    }

    input.keyup(statusUpdate).change(statusUpdate)
    return data
}
